import { useState, useEffect } from 'react'

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768)
    }

    window.addEventListener('resize', handleResize) // Add event listener for window resize

    return () => {
      window.removeEventListener('resize', handleResize) // Remove event listener on component unmount
    }
  }, [])

  return isMobile
}
